import { render, staticRenderFns } from "./message-illustration.vue?vue&type=template&id=cb56f1b8&scoped=true&"
import script from "./message-illustration.vue?vue&type=script&lang=js&"
export * from "./message-illustration.vue?vue&type=script&lang=js&"
import style0 from "./message-illustration.vue?vue&type=style&index=0&id=cb56f1b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb56f1b8",
  null
  
)

export default component.exports